import { DrugDTO } from '@care-portals/api-interfaces';
import { createAction, props } from '@ngrx/store';
import { DrugEntity } from './drug.models';

export const loadDrugs = createAction(
  '[Drug] Load Drugs',
  props<{ filters: any }>()
);

export const loadDrugByDin = createAction(
  '[Drug] Load Drug By DIN',
  props<{ din: string }>()
);

export const loadDrugByDinSuccess = createAction(
  '[Drug] Load Drug By DIN Success',
  props<{ drug: DrugEntity }>()
);

export const loadDrugByDinFailure = createAction(
  '[Drug] Load Drug By DIN Failure',
  props<{ error: string }>()
);

export const clearDrugDetail = createAction('[Drug] Clear Drug Detail');

export const loadDrugsSuccess = createAction(
  '[Drug] Load Drugs Success',
  props<{ drugs: DrugEntity[] }>()
);

export const loadDrugsFailure = createAction(
  '[Drug] Load Drugs Failure',
  props<{ error: any }>()
);

export const saveDrug = createAction(
  '[Drug] Save Drug',
  props<{ drug: DrugDTO }>()
);

export const saveDrugSuccess = createAction(
  '[Drug] Save Drug Success',
  props<{ drug: DrugEntity }>()
);

export const saveDrugFailure = createAction(
  '[Drug] Save Drug Failure',
  props<{ error: any }>()
);

export const updateDrug = createAction(
  '[Drug] Update Drug',
  props<{ id: string; drug: DrugDTO }>()
);

export const updateDrugSuccess = createAction(
  '[Drug] Update Drug Success',
  props<{ drug: DrugEntity }>()
);

export const updateDrugFailure = createAction(
  '[Drug] Update Drug Failure',
  props<{ error: any }>()
);
